import { Fragment, type Node as ProseMirrorNode } from "prosemirror-model";
import type { Transaction } from "prosemirror-state";

import { focusSchema } from "./schema";

const createImageBlock = (image: ProseMirrorNode) =>
  focusSchema.nodes.paragraph.create(null, image);

export const insertImageNodesAtPosition = (
  transaction: Transaction,
  position: number,
  images: ProseMirrorNode[],
) => {
  const safePosition = Math.max(
    0,
    Math.min(position, transaction.doc.content.size),
  );
  const $position = transaction.doc.resolve(safePosition);
  const content = $position.parent.inlineContent
    ? Fragment.fromArray(images)
    : Fragment.fromArray(images.map(createImageBlock));

  return transaction.insert(safePosition, content);
};
